import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import Modal from '../Modal/Modal';
import parse from 'html-react-parser';
import MiniSlideshowGeneric from '../MiniSlideshow/MiniSlideshowGeneric';

// import Summary from '../Summary/Summary';
// import RateDescription from './RateDescription';


class Popup extends Component{

    state={
       popUpActive:true 
    }

    kill=()=>{
       this.props.handleKillPopup();
    }



    PopupForm=()=>{
        // const room = this.props.context.rooms.find(r=>{return r["@attributes"].RoomTypeCode === this.props.roomCode})
        // console.log(this.props);
        // console.log(this.props);
        // let content = "";
        let content = this.props.data.body;
        content = (
            <>
            {parse(content)}
            </>
        );
        // content += <MiniSlideshowGeneric feat={this.props.data.feat} gallery={this.props.data.gallery} />

        return content;
    }

    Slider=()=>{
        if(this.props.data.gallery && this.props.data.gallery.length>0){
            return <MiniSlideshowGeneric feat={this.props.data.feat} gallery={this.props.data.gallery} />
        }
    }

    render(){
        return ReactDOM.createPortal(
        <Modal 
            title={this.props.title} 
            slider={<MiniSlideshowGeneric 
            feat={this.props.data.feat} 
            gallery={this.props.data.gallery} />} 
            help={this.PopupForm()}  kill={this.props.handleKillPopup} 
            bgClose={true}
            extraStyle={"product-popup"}
        />
        ,
        document.getElementById('portal')
        )
    }
}

export default Popup;
